import ffaLogo from "@/assets/loading-logo.png";

interface FFALoaderProps {
  message?: string;
  size?: "sm" | "md" | "lg";
}

export default function FFALoader({ message = "Loading...", size = "md" }: FFALoaderProps) {
  const logoSize = size === "sm" ? "w-10 h-10" : size === "lg" ? "w-20 h-20" : "w-14 h-14";
  const ringSize = size === "sm" ? "w-14 h-14" : size === "lg" ? "w-24 h-24" : "w-18 h-18";

  return (
    <div className="flex flex-col items-center justify-center py-12 gap-4">
      <div className="relative flex items-center justify-center">
        {/* Spinning ring */}
        <svg className={`${ringSize} animate-spin`} viewBox="0 0 64 64" fill="none">
          <circle cx="32" cy="32" r="28" stroke="hsl(var(--muted))" strokeWidth="4" />
          <circle cx="32" cy="32" r="28" stroke="hsl(var(--primary))" strokeWidth="4"
            strokeDasharray="120 60" strokeLinecap="round" />
        </svg>
        {/* Logo in center */}
        <img src={ffaLogo} alt="" className={`absolute ${logoSize} object-contain`} />
      </div>
      <p className="text-xs text-muted-foreground animate-pulse">{message}</p>
    </div>
  );
}
